import React from 'react';

const Fotter = () => {
    return (
        <div>
            <div className='container-fuild mt-5   bg-dark'>
                <h6 className='text-muted italic py-5 text-center'> Hard Work || Dedication || Success</h6>
            </div>
        </div>
    );
};

export default Fotter;